import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=50f87ebf&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=50f87ebf&prod&lang=stylus&scoped=true"
import style1 from "./index1.vue?vue&type=style&index=1&id=50f87ebf&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f87ebf",
  null
  
)

export default component.exports